export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f03a9a94ad99ed8205d3721cedd88b50f6efd0fee&name=fetchTypeahead!'